import React, { useLayoutEffect } from "react";
import { RelayEnvironmentProvider } from "react-relay/hooks";

import { useRelayPrivateEnvironment } from "@whoosh/relay/src";

import { useRefreshLaunchDarklyFlags } from "../../utils/launchDarkly/useRefreshLaunchDarklyFlags";
import { useSchemaVersionMismatchHandler } from "../OtaUpdateOverlay";
import { SentryErrorContent } from "./SentryErrorContent";

type SentryErrorProps = {
  resetError: () => void;
  signOutButton: React.ReactElement;
  eventId: string;
};

export const SentryError = ({
  signOutButton,
  resetError,
  eventId,
}: SentryErrorProps) => {
  const refreshFlags = useRefreshLaunchDarklyFlags();
  const schemaVersionMismatchHandler = useSchemaVersionMismatchHandler();
  const PrivateEnvironment = useRelayPrivateEnvironment({
    schemaVersionMismatchHandler,
  });
  /**
   * If we hit the error screen, try and refresh our LD flags
   * just in case our version is out of date.
   */
  useLayoutEffect(() => {
    refreshFlags();
  }, [refreshFlags]);

  return PrivateEnvironment ? (
    <RelayEnvironmentProvider environment={PrivateEnvironment}>
      <SentryErrorContent {...{ signOutButton, resetError, eventId }} />
    </RelayEnvironmentProvider>
  ) : null;
};
